import { InputNumber } from 'antd'
import { MySlider } from '~/components/ui/MySlider'
import classNames from 'classnames'
import { endingStepAtom, transparentWeightAtom } from './atom'
import { useAtom } from 'jotai'
import styles from '../AiForm.module.css'

export const TransparentParamComp = () => {
  const [transparentWeight, setTransparentWeight] = useAtom(
    transparentWeightAtom
  )
  const [endingStep, setEndingStep] = useAtom(endingStepAtom)

  return (
    <>
      <div className="flex items-center mb-4">
        <span className={classNames('text-neutral-500 w-[120px]')}>权重</span>
        <MySlider
          className="flex-1"
          step={0.1}
          min={0}
          max={2}
          value={transparentWeight}
          onChange={val => {
            setTransparentWeight(val)
          }}
        />
        <InputNumber
          min={0}
          max={2}
          className={styles.inputNumberGroup}
          value={transparentWeight}
          onChange={val => {
            setTransparentWeight(Number(val?.toFixed(1)))
          }}
        />
      </div>
      <div className="flex items-center mb-4">
        <span className={classNames('text-neutral-500 w-[120px]')}>
          Stop At
        </span>
        <MySlider
          className="flex-1"
          step={0.1}
          min={0}
          max={1}
          value={endingStep}
          onChange={val => {
            setEndingStep(val)
          }}
        />
        <InputNumber
          min={0}
          max={1}
          className={styles.inputNumberGroup}
          value={endingStep}
          onChange={val => {
            setEndingStep(Number(val?.toFixed(1)))
          }}
        />
      </div>
    </>
  )
}
